/*
  Sticky ATC ↔ SMART Discounts bundle sync (2026 product template only).

  When the SMART Discounts widget (<bundle-deals-widget>) is on the page, the
  sticky add-to-cart bar's price is wrong (shows the single, undiscounted
  variant price) and its variant selector is meaningless (the widget owns the
  variants). This mirrors the SELECTED offer's discounted total into the sticky
  bar and flags it with `has-bundle-app` so CSS hides the sticky variant picker.

  The add-to-cart button itself is left alone — the app already intercepts the
  sticky form submit and adds the correct bundle. Regular products (no widget)
  are unaffected: nothing runs.
*/
(function () {
   var WIDGET_SEL = 'bundle-deals-widget';
   var STICKY_SEL = 'sticky-add-to-cart, [data-sticky-add-to-cart]';

   function start(widget, sticky) {
      var applying = false;
      var current = { price: '', compare: '' };

      // Push the selected offer's total + pair-count badge into the sticky bar
      function apply() {
         var active = widget.querySelector('.bd-tier--active');
         if (!active) return; // widget not rendering offers yet
         var priceEl = active.querySelector('.bd-tier__price');
         var price = priceEl ? priceEl.textContent.trim() : '';
         if (!price) return;
         var compareEl = active.querySelector('.bd-tier__compare');
         var compare = compareEl ? compareEl.textContent.trim() : '';
         // Tiers are consecutive quantities (1,2,3,4 → index + 1). Single (1) gets no badge.
         var idxAttr = active.getAttribute('data-tier-index');
         var qty = idxAttr === null ? 0 : (parseInt(idxAttr, 10) || 0) + 1;

         current = { price: price, compare: compare };
         sticky.classList.add('has-bundle-app');
         applying = true;

         sticky.querySelectorAll('.money-subtotal').forEach(function (el) {
            if (el.textContent.trim() !== price) el.textContent = price;
         });

         sticky.querySelectorAll('.sticky-price').forEach(function (pr) {
            var cmp = pr.querySelector('.money-compare-price');
            if (compare && compare !== price) {
               if (!cmp) {
                  cmp = document.createElement('s');
                  cmp.className = 'money-compare-price';
                  pr.insertBefore(cmp, pr.firstChild);
               }
               if (cmp.textContent.trim() !== compare) cmp.textContent = compare;
               pr.classList.add('has-compare-price');
            } else if (cmp) {
               cmp.remove();
               pr.classList.remove('has-compare-price');
            }
         });

         // Pair-count badge (×2 / ×3 / ×4) prepended before the product name
         sticky.querySelectorAll('.sticky-title').forEach(function (title) {
            var badge = title.querySelector('.bd-qty-badge');
            if (qty > 1) {
               if (!badge) {
                  badge = document.createElement('span');
                  badge.className = 'bd-qty-badge';
                  title.insertBefore(badge, title.firstChild);
               }
               var txt = '×' + qty;
               if (badge.textContent !== txt) badge.textContent = txt;
               badge.hidden = false;
            } else if (badge) {
               badge.hidden = true;
            }
         });

         window.requestAnimationFrame(function () {
            applying = false;
         });
      }

      // Source of truth: re-sync whenever the widget's selected tier changes / re-renders
      new MutationObserver(apply).observe(widget, {
         subtree: true,
         childList: true,
         characterData: true,
         attributes: true,
         attributeFilter: ['class'],
      });
      widget.addEventListener('change', apply);
      widget.addEventListener('click', function () {
         window.setTimeout(apply, 60);
      });

      // Guard: re-assert the bundle price if the theme's variant scripts overwrite it
      new MutationObserver(function () {
         if (applying || !current.price) return;
         apply();
      }).observe(sticky, { subtree: true, childList: true, characterData: true });

      apply();
   }

   // The <bundle-deals-widget> element exists on every 2026 product but stays
   // EMPTY unless SMART Discounts actually renders offers (.bd-tier) into it.
   // Flag the page only when real tiers are present so the product-info price
   // block is hidden on bundle products, but stays visible everywhere else.
   function reflectBundle(widget) {
      var has = !!widget.querySelector('.bd-tier');
      document.documentElement.classList.toggle('bundle-active', has);
   }

   function init() {
      var widget = document.querySelector(WIDGET_SEL);
      if (widget) {
         reflectBundle(widget);
         // The app renders tiers asynchronously — keep the flag in sync as content appears.
         if (!widget.__bundleWatched) {
            widget.__bundleWatched = true;
            new MutationObserver(function () {
               reflectBundle(widget);
            }).observe(widget, { subtree: true, childList: true });
         }
      }
      var sticky = document.querySelector(STICKY_SEL);
      if (!widget || !sticky) return false;
      start(widget, sticky);
      return true;
   }

   function boot() {
      if (init()) return;
      // The app block / sticky bar can appear late; retry briefly then give up
      var tries = 0;
      var timer = window.setInterval(function () {
         if (init() || ++tries > 40) window.clearInterval(timer);
      }, 250);
   }

   if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
   } else {
      boot();
   }
})();
